import React, { useState, useRef } from 'react';
import { MunshiMenu } from "../components/Menu";
import { InputNumber } from 'primereact/inputnumber';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { axiosInstance } from "../utilities/AxiosConfig";
import { notify } from "../components/toast";
import { useSpinner } from "../context/SpinnerContext";
import {number} from "prop-types";

export default function DocumentUploader({ handle }) {
    const [refNumber, setRefNumber] = useState(0);
    const [docType, setDocType] = useState('INV');
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const { setLoading } = useSpinner();

    const docOptions = [
        { label: 'Invoice', value: 'SALE' },
        { label: 'Purchase', value: 'PURC' },
        { label: 'Cashbook', value: 'CASH' },
        { label: 'Voucher', value: 'VCHR' }
    ];

    const onTemplateSelect = (e) => {
        setFiles(e.files);
    };

    const uploadFilesSequentially = async () => {
        if (refNumber <= 0) {
            notify("Please enter a valid reference number", "error");
            return;
        }
        if (files.length === 0) {
            notify("No files selected", "error");
            return;
        }

        setUploading(true);
        setLoading(true);

        try {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const formData = new FormData();
                const paddedString = refNumber.toString().padStart(5, '0');
                // Construct new filename: TYPE_REF_INDEX_ORIGINALNAME
                const newName = `${docType}-${paddedString}_${i + 1}_${file.name}`;

                formData.append('image', file, newName);
                formData.append('name', paddedString);
                formData.append('mode', docType);

                await axiosInstance.post('image/', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                setProgress(Math.round(((i + 1) / files.length) * 100));
            }
            notify("All documents uploaded successfully", "success");
            setFiles([]);
        } catch (error) {
            notify(`Upload failed: ${error.message}`, "error");
        } finally {
            setUploading(false);
            setLoading(false);
            setProgress(0);
        }
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                {chooseButton}
                {cancelButton}
                <div className="ml-auto">
                    <Button
                        label="Save All"
                        icon="pi pi-save"
                        onClick={uploadFilesSequentially}
                        className="p-button-primary"
                        disabled={files.length === 0 || uploading}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="p-2">
            <MunshiMenu handle={handle} />

            <div className="card mt-3 p-4 shadow-2">
                <div className="flex justify-content-between align-items-center mb-4">
                    <h2 className="m-0">Batch Document Uploader</h2>
                </div>

                <div className="grid mb-4">
                    <div className="col-12 md:col-4">
                        <label className="block font-bold mb-2">Document Type</label>
                        <Dropdown
                            value={docType}
                            options={docOptions}
                            onChange={(e) => setDocType(e.value)}
                            placeholder="Select Type"
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 md:col-4">
                        <label className="block font-bold mb-2">Reference / Folio #</label>
                        <InputNumber
                            value={refNumber}
                            onValueChange={(e) => setRefNumber(e.value)}
                            onFocus={(e) => e.target.select()}
                            useGrouping={false}
                            placeholder="Enter Number"
                            className="w-full"
                        />
                    </div>
                </div>

                {uploading && (
                    <div className="mb-4">
                        <span className="text-sm mb-2 block text-primary font-bold">Processing Files: {progress}%</span>
                        <ProgressBar value={progress} style={{ height: '10px' }} />
                    </div>
                )}

                <FileUpload
                    name="files[]"
                    multiple
                    accept="image/jpeg,application/pdf"
                    maxFileSize={5000000}
                    onSelect={onTemplateSelect}
                    onClear={() => setFiles([])}
                    headerTemplate={headerTemplate}
                    emptyTemplate={
                        <div className="flex align-items-center justify-content-center flex-column py-5 border-2 border-dashed border-300 border-round">
                            <i className="pi pi-cloud-upload text-4xl text-400 mb-3"></i>
                            <p className="m-0 text-600">Drag and drop JPEG images or PDF files here.</p>
                        </div>
                    }
                />
            </div>
        </div>
    );
}